import { render } from "./AddLanguageSteps.vue?vue&type=template&id=09118bd3&scoped=true"
import script from "./AddLanguageSteps.vue?vue&type=script&lang=js"
export * from "./AddLanguageSteps.vue?vue&type=script&lang=js"

import "./AddLanguageSteps.vue?vue&type=style&index=0&id=09118bd3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09118bd3"]])

export default __exports__